<template>
  <div class="applyhistory-container">
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-select
      :placeholder="this.$t('app.isApplyHostel')"
      v-model="search.isApply"
      style="width: 200px; margin-right: 10px"
      size="small"
    >
      <el-option label="是" :value="'1'"></el-option>
      <el-option label="否" :value="'0'"></el-option>
    </el-select>
    <el-button type="primary" @click="reset" size="small">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      @click="getList"
      icon="el-icon-search"
      size="small"
      >{{ $t("app.search") }}</el-button
    >
    <el-button
      type="primary"
      icon="el-icon-document"
      @click="handleDownload"
      size="small"
    >
      Export
    </el-button>
    <div class="table-container">
      <el-table
        :data="tableData"
        height="620"
        style="width: 100%; color: black"
        @sort-change="sortChange"
      >
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'room' ||
              col.model === 'lastApplyDate' ||
              col.model === 'studentNumber'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getList } from "@/api/dormitoryManagement/hostelApplyList";
import { delEmpty, downloadFileByBlob, formatDate } from "@/utils/utils";
import { download } from "@/api/download";
export default {
  components: {},
  data() {
    return {
      auto: false,
      time: "",
      loading: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "contact", label: this.$t("app.contactInformation") },
      ],
      column: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "englishName", label: this.$t("app.nameEnglish") },
        { model: "chineseName", label: this.$t("app.nameChina") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        {
          model: "room",
          label: this.$t("app.currentRoom"),
        },
        {
          model: "lastApplyDate",
          label: this.$t("app.applyDate"),
        },
        {
          model: "isContinue",
          label: this.$t("app.isStayover"),
        },
        {
          model: "IsSameRoom",
          label: this.$t("app.isKeepRoom"),
        },
      ],
      search: {
        studentNumber: "",
        contact: "",
        name: "",
        isApply: "",
        orderKey: "",
        orderType: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getList(
        delEmpty({
          Name: this.search.name,
          StudentID: this.search.studentNumber,
          Contact: this.search.contact,
          HasApply: this.search.isApply,
          PageIndex: this.currentPage,
          PageSize: this.size,
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
        })
      ).then((res) => {
        this.total = res.data.Total;
        if (res.data.Items == null) {
          this.tableData = [];
          this.total = 0;
          return;
        }
        this.tableData = res.data.Items.map((item) => {
          return {
            englishName: item.Name,
            chineseName: item.ChineseName,
            studentNumber: item.StudentID,
            contactInformation: item.Contact,
            room: item.CurrentRoom,
            lastApplyDate: item.LastApplyDate,
            isContinue: item.LodgeType,
            IsSameRoom: item.IsSameRoom,
          };
        });
      });
    },
    reset() {
      this.search.studentNumber = "";
      this.search.contact = "";
      this.search.name = "";
      this.search.isApply = "";
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleDownload() {
      download(
        "/HostelApplicationStatusList/Export",
        delEmpty({
          Name: this.search.name,
          StudentID: this.search.studentNumber,
          Contact: this.search.contact,
          HasApply: this.search.isApply,
        })
      ).then((content) => {
        var blobContent = new Blob([content]);
        downloadFileByBlob(
          blobContent,
          "Hostel Application-" + formatDate(new Date(), "yyyy-MM-dd") + ".xls"
        );
      });
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.applyhistory-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 100px);
  .table-container {
    height: calc(100% - 150px);
    overflow: auto;
  }
}
</style>
